module.exports = __webpack_public_path__ + "img/bg_1_3.a1c3c8da.jpg";